import { OreButton, OreStack, OreText } from '@edenredespana/oreneta'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { GenesysCoBrowsing } from '@/Shared/ui/genesys/GenesysCoBrowsing'

import { HelpCenterTranslations } from '../helpCenterTranslations'

export const CoBrowsing = (): JSX.Element => {
  const { t } = useTranslation()
  const [loadGenesysScript, setLoadGenesysScript] = useState<boolean>(false)

  return (
    <OreStack space="medium">
      <OreStack space="xsmall">
        <OreText bold>
          {t(HelpCenterTranslations.coBrowsing.expandableFaq.content.title)}
        </OreText>
        <OreText>
          <Trans t={t}>
            {t(HelpCenterTranslations.coBrowsing.expandableFaq.content.description)}
          </Trans>
        </OreText>
      </OreStack>
      <OreStack space="xsmall" placeContent="center">
        <OreButton
          type="button"
          category="primary"
          onClick={() => setLoadGenesysScript(true)}
        >
          {t(HelpCenterTranslations.coBrowsing.expandableFaq.content.button)}
        </OreButton>
      </OreStack>
      {loadGenesysScript && <GenesysCoBrowsing />}
    </OreStack>
  )
}
